import React, { useState, useEffect, useLayoutEffect } from "react";
import { Redirect } from 'react-router-dom'
import { useIntl, FormattedMessage } from 'react-intl'
import * as Utils from '../../commons/utils/Utils'
import {
  Collapse,
  TextField,
  CircularProgress,
  Grid,
  Box,
} from '@material-ui/core';
import Switch from "react-switch";
import Autocomplete from '@material-ui/lab/Autocomplete';


const FILTER_STATE_INIT = {
	estado: 'PENDIENTE',
	id: '',
	tipoFormulario: '',
	fecha: '',
	base: [],
	transportadora: '',
	centroCostos: '',
	dominio: '',
	showInactivos: false,
};

const QUERY_INIT = {
	id: '',
	fecha: '',
	tipoFormulario: '',
	base: '',
	transportadora: '',
	centroCostos: '',
	dominio: '',
	estado: 'PENDIENTE'
}

const getFilterStateInit = (intl) => {
	let filtersState = JSON.parse(JSON.stringify(FILTER_STATE_INIT));
	filtersState.estado = { label: intl.formatMessage({ id: "SafeFeedbackFormularioGridFilters.render.filtros_estado.opciones.pendientes", defaultMessage: "Pendientes" }), value: 'PENDIENTE' };
	return filtersState;
}

const handleInitFilters = (intl) => {
	let filterInit = getFilterStateInit(intl)
	let storage = JSON.parse(window.localStorage.getItem('SafeFeedbackFormularioGridFilters'))
	if(storage && storage.activo && storage.filtros){
		filterInit = storage.filtros
	}
	return filterInit
}

const SafeFeedbackFormularioGridFiltros = (props) => {
	const intl = useIntl();
	const [init, setInit] = useState(false)
	const [filtersLoading, setFiltersLoading] = useState(false);
	const [filtersState, setFiltersState] = useState(handleInitFilters(intl));
	const [bases, setBases] = useState([]);
	const [transportadoras, setTransportadoras] = useState([]);
	const [centrosCostos, setCentrosCostos] = useState([]);
	const [validatorSearch, setValidatorSearch] = useState(false)
	const columnsEnabled = props.columnsEnabled
	const estados = [
		{ label: intl.formatMessage({ id: "SafeFeedbackFormularioGridFilters.render.filtros_estado.opciones.todos", defaultMessage: "Todos" }), value: '' },
		{ label: intl.formatMessage({ id: "SafeFeedbackFormularioGridFilters.render.filtros_estado.opciones.pendientes", defaultMessage: "Pendientes" }), value: 'PENDIENTE' },
		{ label: intl.formatMessage({ id: "SafeFeedbackFormularioGridFilters.render.filtros_estado.opciones.confirmados", defaultMessage: "Confirmados" }), value: 'CONFIRMADO' },
		{ label: intl.formatMessage({ id: "SafeFeedbackFormularioGridFilters.render.filtros_estado.opciones.desestimados", defaultMessage: "Desestimados" }), value: 'DESESTIMADO' },
	]

	useEffect(() => {
		fetchData()
		initFilter()
	}, []);

	useEffect(() => {
		if(props.filterResetInputs){
			setFiltersState(JSON.parse(JSON.stringify(getFilterStateInit(intl))));
			window.localStorage.setItem('SafeFeedbackFormularioGridFilters',JSON.stringify({activo: false, filtros: getFilterStateInit(intl)}));
		}
	},[props.filterResetInputs])

	useEffect(() => {
		!props.dropdownActive && props.setFilterResetInputs(false)
		!props.dropdownActive && setFiltersLoading(false)
	}, [props.dropdownActive]);

	useEffect(() => {
		if(props.filterKpi){
			filtersState.id = ''
			filtersState.fecha = ''
			filtersState.tipoFormulario = ''
			filtersState.base = []
			filtersState.dominio = ''
			filtersState.estado = estados.find((estado) => estado.value === props.filterKpi)
			persistentFilter(true);
			props.handleFilterChange();
			props.setSearchActive(true)
			let query = queryTable();
			props.setFilterQuery(query);
		}
	}, [props.filterKpi]);

	useEffect(() => {
		if(init){
			if(props.persisteFiltros){
				window.localStorage.setItem('SafeFeedbackFormularioGridFilters', JSON.stringify({activo: true, filtros: filtersState}));
			}
			else{
				setFiltersState(JSON.parse(JSON.stringify(getFilterStateInit(intl))));
				props.setFilterQuery(JSON.parse(JSON.stringify(QUERY_INIT)));
				window.localStorage.setItem('SafeFeedbackFormularioGridFilters',JSON.stringify({activo: false, filtros: getFilterStateInit(intl)}));
			} 
		}
	},[props.persisteFiltros])

	useEffect(() => {
		setValidatorSearch(validator());
	},[filtersState])

	const initFilter = () => {
		setFiltersLoading(true);
		let query = {}

		if(props.persisteFiltros || validatorNotNull()){
			props.setSearchActive(true);
		}
		
		query = queryTable();
		
		setInit(true)
		
		window.localStorage.setItem('SafeFeedbackFormularioGridFilters',JSON.stringify({activo: props.persisteFiltros, filtros: filtersState}));
		props.setFilterQuery(query);
		setFiltersLoading(false)
		return;
	}

	const persistentFilter = (value) => {
		if (props.persisteFiltros) {
			window.localStorage.setItem('SafeFeedbackReportesGridFilter', JSON.stringify({activo: value, filtros: filtersState}));
		}
	}

	const validatorNotNull = () => {
		var result = Object.entries(filtersState);
		for (var index in result){
			if(result[index] && result[index][0]==='estado'){
				if(result[index][1] && result[index][1].value === 'PENDIENTE'){
					continue
				}
			}
			if(Array.isArray(result[index][1])){
				if(result[index][1].length > 0){
					return true
				}
			}else{
				if(result[index][1]){
					return true
				}
			}
		}
		return false
	}

	const fetchData = () => {
		let transportadorasReq = null;
		let centrosCostosReq = null;
		if (props.transportadoraGrilla) {
			transportadorasReq = Utils.getData('/transportadoras/select')
				.then((responseTransportadoras) => {
					setTransportadoras(responseTransportadoras || []);
				})
				.catch((err) => {
					console.log(err);
				});

			centrosCostosReq = Utils.getData('/centros-costos/select')
				.then((responseCentrosCostos) => {
					setCentrosCostos(responseCentrosCostos || []);
				})
				.catch((err) => {
					console.log(err);
				});
		}
		const basesReq =Utils.getData('/bases/select-filtered-by-user')
		.then((bases) => {
			setBases(bases)
		}).catch((err) => {
			console.log(err);
		})

		Promise.all([basesReq, transportadorasReq, centrosCostosReq])
			.finally(() => {
				setFiltersLoading(false);
			});
	}

	const handleChange = (name, object) => {
		try {
			setFiltersState((prevState) => {
				const updatedFiltersState = { ...prevState, [name]: object };                
				return updatedFiltersState;
			});
		} catch (error) {
			console.error("Error al manejar el cambio de filtros:", error);
		}
	};

	const handleOnEnter = (e, name, value) => {
		if (e.keyCode === 13) {
			e.preventDefault();
			handleChange(name, value);
		}
	};

	const queryTable = () => {
		let query = {}
		query = JSON.parse(JSON.stringify(filtersState));
		query['base'] = filtersState.base ? filtersState.base.map(e => e.value).join(',') : ''
		query['transportadora'] = filtersState.transportadora ? filtersState.transportadora.id : ''
		query['centroCostos'] = filtersState.centroCostos ? (filtersState.centroCostos.id || filtersState.centroCostos.value) : ''
		query['tipoFormulario'] = filtersState.tipoFormulario ? filtersState.tipoFormulario : ''
		query['estado'] = filtersState.estado ? filtersState.estado.value : ''
		query['fecha'] = filtersState.fecha ? filtersState.fecha : ''
		query['id'] = filtersState.id ? filtersState.id : ''
		return query;
	}
  
	const validator = () => {
		var result = Object.entries(filtersState);
		for (var index in result){
			if(Array.isArray(result[index][1])){
				if(result[index][1].length > 0 ){
					return false
				}
			}else{
				if(result[index][1]){
					return false
				}
			}
		}
		return true
	}

	useEffect(() => {
		setValidatorSearch(validator());
	},[filtersState])

	const onChangePersistentFilter = (value) => {
		window.localStorage.setItem('SafeFeedbackFormularioGridFilters', JSON.stringify({activo: value, filtros: filtersState}));
		props.setPersisteFiltros(value)
	}

	const handleSubmitInto = (event) => {
		if(!props.loading && !validatorSearch){
			handleSubmit(event);
		}
		event.preventDefault();
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		props.setSearchActive(true)
		let query = queryTable();
		props.setFilterQuery(query);
		return;
	}

	return (
		<>
			{init && (
				<Collapse in={props.dropdownActive}>
					<Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
						<Grid {...(!columnsEnabled.id && { display: 'none' })} component={Box} item xs={1}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'safeFeedbackFormularioGridFilters.render.filtros_id.label',
										defaultMessage: 'Id',
									})}
									name="id"
									value={filtersState.id}
									onChange={(e) => {handleChange('id', e.target.value)}}
									disabled={filtersLoading}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Autocomplete
									size="small"
									name="estado"
									disabled={filtersLoading}
									options={estados}
									value={filtersState.estado}
									getOptionLabel={(option) => (option ? option.label : '')}
									onChange={(e, value) => {handleChange('estado', value)}}
									renderInput={(params) => (
										<TextField
										{...params}
										variant="standard"
										label={intl.formatMessage({
											id: 'SafeFeedbackFormularioGridFiltros.render.filtros_estado.label',
											defaultMessage: 'Estado',
										})}
										/>
									)}
								/>
							</form>
						</Grid>
						<Grid
							{...(!columnsEnabled.tipoFormulario && { display: 'none' })}
							component={Box}
							item
							xs={3}
						>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'SafeFeedbackFormularioGridFilters.render.filtros_tipoFormulario.label',
										defaultMessage: 'Tipo de Formulario',
									})}
									name="tipoFormulario"
									value={filtersState.tipoFormulario}
									onChange={(e) => {handleChange('tipoFormulario', e.target.value)}}
									disabled={filtersLoading}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid {...(!columnsEnabled.fecha && { display: 'none' })} component={Box} item xs={2}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'SafeFeedbackFormularioGridFilters.render.filtros_fecha_hora.label',
										defaultMessage: 'Fecha',
									})}
									name="fecha"
									value={filtersState.fecha}
									onChange={(e) => {handleChange('fecha', e.target.value)}}
									disabled={filtersLoading}
									className="col-12"
									type="date"
									// isClearable={true}
									format={'DD-MM-YYYY'}
									// disableFuture
									InputLabelProps={{
										shrink: true,
									}}
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'safeFeedbackFormularioGridFilters.render.filtros_placa.label',
										defaultMessage: 'Placa',
									})}
									name="dominio"
									value={filtersState.dominio}
									onChange={(e) => {handleChange('dominio', e.target.value)}}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Autocomplete
									size="small"
									name="base"
									multiple={true}
									disabled={filtersLoading}
									options={bases}
									defaultValue={[]}
									value={filtersState.base}
									getOptionLabel={(option) => (option ? option.label : '')}
									onChange={(e, value) => {handleChange('base', value)}}
									onKeyDown={(e) => handleOnEnter(e, 'base', filtersState.base)}
									renderInput={(params) => (
										<TextField
										{...params}
										variant="standard"
										label={intl.formatMessage({
											id: 'safeFeedbackFormularioGridFilters.render.filtros_base.label',
											defaultMessage: 'Base',
										})}
										/>
									)}
								/>
							</form>
						</Grid>
						{props.transportadoraGrilla && (
							<Grid component={Box} item xs={3}>
								<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
									<Autocomplete
										size="small"
										name="transportadora"
										options={transportadoras}
										value={filtersState.transportadora}
										defaultValue={null}
										getOptionLabel={(option) => option ? option.nombre : ""}
										onChange={(e, value) => handleChange('transportadora', value)}
										renderInput={(params) => (
										<TextField {...params} variant="standard"
											label={intl.formatMessage({ id: "SafeFeedbackFormularioGridFiltros.render.filtros_transportadora.label", defaultMessage: "Transportadora" })}
											placeholder={intl.formatMessage({ id: "SafeFeedbackFormularioGridFiltros.render.filtros_transportadora.placeholder", defaultMessage: "Transportadora" })}
											InputProps={{
											...params.InputProps,
											endAdornment: (
											<React.Fragment>
												{filtersLoading ? (
													<CircularProgress color="inherit" size={21} />
												) : null}
												{params.InputProps.endAdornment}
											</React.Fragment>
											),
											}}
										/>
										)}
									/>
								</form>
							</Grid>
						)}
						{props.transportadoraGrilla && (
							<Grid component={Box} item xs={3}>
								<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
									<Autocomplete
										size="small"
										name="centroCostos"
										options={centrosCostos}
										value={filtersState.centroCostos}
										defaultValue={null}
										getOptionLabel={(option) => option ? option.label : ""}
										onChange={(e, value) => handleChange('centroCostos', value)}
										renderInput={(params) => (
										<TextField {...params} variant="standard"
											label={intl.formatMessage({ id: "SafeFeedbackFormularioGridFiltros.render.filtros_centroCosto.label", defaultMessage: "Centro de Costos" })}
											placeholder={intl.formatMessage({ id: "SafeFeedbackFormularioGridFiltros.render.filtros_centroCosto.placeholder", defaultMessage: "Centro de Costos" })}
											InputProps={{
											...params.InputProps,
											endAdornment: (
											<React.Fragment>
												{filtersLoading ? (
													<CircularProgress color="inherit" size={21} />
												) : null}
												{params.InputProps.endAdornment}
											</React.Fragment>
											),
											}}
										/>
										)}
									/>
								</form>
							</Grid>
						)}
						<Grid
							xs={12}
							container
							justifyContent="space-between"
							alignItems="center"
							flexDirection={{ xs: 'column', sm: 'row' }}
							sx={{ fontSize: '12px' }}
						>
							<Grid component={Box} item xs={2} className="align-self-end">
								<div className="d-flex inline justify-content-around align-items-center">
									<FormattedMessage
										id="SafeFeedbackFormularioGridFiltros.render.filtros.persistir_filtros"
										defaultMessage="Persistir Filtros"
									/>
									<Switch
										onChange={(value) => onChangePersistentFilter(value)}
										checked={props.persisteFiltros}
										disabled={filtersLoading}
										offColor="#FF4961"
										onColor="#28D094"
									/>
								</div>
							</Grid>
							<Grid component={Box} item xs={1} className="align-self-end">
								<button
									disabled={props.loading}
									className="btn btn-primary mr-1"
									onClick={(e) => handleSubmit(e)}
								>
									<i className="fa fa-search fa-xs"></i>   <FormattedMessage id="Buscar" defaultMessage="Buscar"/>
								</button>
							</Grid>
						</Grid>
					</Grid>
				</Collapse>
			)}
		</>
	);
}

export default SafeFeedbackFormularioGridFiltros
